import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileLock"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M14.025 1.725C13.8913 1.57686 13.6995 1.49465 13.5 1.5H6C5.17157 1.5 4.5 2.17158 4.5 3V21C4.5 21.8284 5.17157 22.5 6 22.5H10.2012V21H6V4.46505V3.00002H12V7.50002C12 8.32845 12.6716 9.00002 13.5 9.00002H18V11.4757H19.5V7.5C19.5054 7.30052 19.4231 7.10869 19.275 6.975L14.025 1.725ZM13.5 3.29999L17.7 7.49999H13.5V3.29999ZM18.75 16.3716H18V15C18 13.725 17.025 12.75 15.75 12.75C14.475 12.75 13.5 13.725 13.5 15V16.3716H12.75C12.3 16.3716 12 16.6716 12 17.1216V21.6216C12 22.0716 12.3 22.3716 12.75 22.3716H18.75C19.2 22.3716 19.5 22.0716 19.5 21.6216V17.1216C19.5 16.6716 19.2 16.3716 18.75 16.3716ZM15 14.9946C15 14.4996 15.3375 14.1216 15.75 14.1216C16.1625 14.1216 16.5 14.4996 16.5 14.9946V16.3716H15V14.9946ZM18 20.8716H13.5V17.8716H18V20.8716Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileLock.vue"]]);
